export default __webpack_public_path__ + "static/media/self-pic-2.ff772317.png";